export const timeEntryStatusValues = ['open', 'closed'] as const;
export type TimeEntryStatus = (typeof timeEntryStatusValues)[number];

export interface TimeEntryDto {
  id: string;
  companyId: string;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  employeeId: string;
  status: TimeEntryStatus;
  clockInAt: string;
  clockOutAt: string | null;
  totalMinutes: number | null;
  isAdjusted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ClockInRequest {
  companyId: string;
  employeeId: string;
  storeId?: string;
  locationId?: string;
  stationId?: string;
}

export interface ClockInResponse {
  timeEntry: TimeEntryDto;
}

export interface ClockOutRequest {
  companyId: string;
  timeEntryId: string;
}

export interface ClockOutResponse {
  timeEntry: TimeEntryDto;
}

export interface ListTimeEntriesRequest {
  companyId: string;
  employeeId?: string;
  from?: string;
  to?: string;
}

export interface ListTimeEntriesResponse {
  items: TimeEntryDto[];
}

export interface AdjustTimeEntryRequest {
  companyId: string;
  timeEntryId: string;
  newClockInAt: string;
  newClockOutAt: string | null;
  reason: string;
}

export interface AdjustTimeEntryResponse {
  timeEntry: TimeEntryDto;
}

export interface SelfClockInRequest {
  companyId: string;
}

export interface SelfClockOutRequest {
  companyId: string;
}

export interface GetSelfTimeEntryStatusRequest {
  companyId: string;
}

export interface GetSelfTimeEntryStatusResponse {
  openTimeEntry: TimeEntryDto | null;
}
